import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static password(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const regex =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

      const isValid = regex.test(value);

      return isValid
        ? null
        : {
            password: {
              requiredPattern: true,
            },
          };
    };
  }

  static confirmation(passwordField: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;
      if (!formGroup) return null;

      const parentControl = formGroup.get(passwordField)?.value;
      const confirmValue = control.value || '';

      return parentControl === confirmValue
        ? null
        : {
            confirmation: {
              message: true,
            },
          };
    };
  }

  static atLeastOneFilled(fields: string[]): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const isAnyFilled = fields.some((field) => {
        const control = formGroup.get(field);

        const value = control?.value;
        return value !== null && value !== undefined && value !== '';
      });

      return isAnyFilled
        ? null
        : {
            atleastonefilled: {
              fields,
            },
          };
    };
  }

  static requiredCheckbox(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || false;

      return value
        ? null
        : {
            requiredcheckbox: true,
          };
    };
  }
}
